import React,{useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import { v4 as uuidv4 } from 'uuid'


import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import line_icon from '../../assets/images/icons/line-icon.png'
import PaymentModel from './models/paymentModel'
import mtn_card from '../../assets/images/mtn-card.png'
import airtel_card from '../../assets/images/airtel-card.png'
import bank_icon from '../../assets/images/icons/bank-icon.png'

import {
    submitPayment,
    clearPaymentLoader,
    generateBillId,
    clearPayments
} from '../../actions'
import {SUBMIT_APPLICATION_ID, MAKING_PAYMENT_LOADING_ID} from '../../store/loaders'
import SuccessfulModel from '../../components/successfulModel'






const ApllicationPaymentDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {hasPaid,
            individualApplication, 
            loader, 
            hasUpdatedIndividualApplication,
            firmApplication,
            generatedBillId
        } = state
        const {message} = hasPaid
        const {application} = individualApplication
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading: false}
        const payLoader = loader[MAKING_PAYMENT_LOADING_ID]
        const {billId} = generatedBillId
        return{
            message,
            application,
            isLoading,
            payLoader,
            message,
            hasUpdatedIndividualApplication,
            firmApplication,
            billId
            
        }
    })

    const applicationId = apiResponse.application?.id
    const firmApplicationId = apiResponse.firmApplication?.application?.id
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    const actionLoader = apiResponse.isLoading
    const referenceId = props.location?.state?.application?.id || props.location?.state?.referenceId
    var firstName = props.location?.state?.firstTime || currentUser.given_name
    var lastName = props.location?.state?.lastname  || currentUser.family_name
    var firm = props.location?.state?.isFirm
    var isMembership = props.location?.state?.isMembership
    var headerSection = props.location?.state?.headerSection



    

    const [showModel, setShowModel] = useState(false)
    const [title, setTitlle] = useState('')

    const [changeView, setChangeView] = useState(true)
    const [payLater, setPayLater] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [paymentStatus, setPaymentStatus] = useState('pending')
    const [showSuccessModel, setSuccessModel] = useState(false)
    const [firstLoad, setFirstLoad] = useState(true)

    const [applicationDetails,
        setApplicationDetails] = useState({})

    
    const handlePhoneNumber = (text)=>{
        setPhoneNumber(text.target.value)
    }

    useEffect(()=>{
        dispatch(clearPayments())
    },[])

    useEffect(()=>{
        if(apiResponse.message !== ''){
            setChangeView(false)
            setPaymentStatus(apiResponse.message?.status)
        }
        if(firstLoad){
            dispatch(generateBillId({
                id: referenceId,
                type: isMembership ? isMembership : firm ? 2 : 1
            }))
            setFirstLoad(true)
        }
    },[apiResponse.message])

    //apiResponse.billId?.amount
    const handlePayNow = ()=>{
        dispatch(submitPayment({
            data:{
                amount: '10',
                payer: currentUser.name,
                billId: apiResponse.billId?.id,
                userId: currentUser.sub,
                referenceId: applicationId || firmApplicationId,
                paymentMethod: 1,
                account: "25"+phoneNumber,
                paymentPurpose: firm? "FIRM APPLICATION" : "INDIVIDUAL APPLICATION",
                payerName: `${firstName} ${lastName}`,
                requestId: uuidv4()
            },
        }))
      }
    
      const handlePayLater = ()=>{
          setChangeView(false)
          setPayLater(true)
      }
    const togglePaymentModel = (method)=>{
        setPaymentMethod(method)
        setChangeView(true)
        setPayLater(false)
        setShowModel(!showModel)
    }

    const handleCloseSuccessModel = ()=>{
        setSuccessModel(!showSuccessModel)
        history.push('/dashboard')
        dispatch(clearPaymentLoader('data'))
    }

    const handleCancel = ()=>{
        if (headerSection){
            history.push('/billers')
        }else{
            history.push('/dashboard')
        }
     }
    return (
        <div>
            {!headerSection && 
            <DashboardHeader 
                activeStep={8}
                application={props.location?.state?.application}
                />}
            <DashBoardContainer 
                handleClose={handleCancel}
                handleCloseMembership={handleCancel}
                title="Submit"
                middleTitle="Upload"
                disabled={apiResponse.payLoader?.isLoading}
                payLoader={actionLoader}
                hasButton={true}
                isFetching={!apiResponse.application}
                hasCloseBtn={true}
                closeTitle="Pay Later"
                >
                <div className="payment-details-container">
                    <span>Amount to pay for <br/>
                    <span style={{fontWeight: '900'}}>{apiResponse.billId?.description} </span></span>
                </div>
                <div className="payment-amount-details-ctn">
                    <span className="payment-amount-text">{apiResponse.billId?.amount}{" "}{apiResponse.billId?.currency}</span>
                </div>
                <div style={{
                    width: '100%',
                    padding: '20px 0px'
                }}>
                    <img src={line_icon} style={{width: '100%'}}/>
                </div>
    
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems:'center',
                    padding: 30
                }}>
                    <span className="general-span-text-none-auto" style={{fontSize: 30}}>Choose Payment Methods to use</span>
                </div>
                <div className="payments-card-container" style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                    {
                        apiResponse.billId?.currency?.toUpperCase() === 'RWF' &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', marginRight: 50}}
                            onClick={()=>{togglePaymentModel('MTN'); setTitlle('Payment via Mobile Money')}}>
                            <span className="general-span-text-none-auto">MTN</span>
                            <div className="item">
                                <img alt="mtn" src={mtn_card}/>
                            </div>
                        </div>
                    }
                    {/* <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',cursor: 'pointer'}}
                        onClick={()=>{togglePaymentModel('AIRTEL'); setTitlle('Payment via AIRTEL Money')}}>
                        <span className="general-span-text-none-auto">AIRTEL</span>
                        <div className="item">
                            <img alt="airtel" src={airtel_card}/>
                        </div>
                    </div> */}
                    <div className="item-visa-master-card"
                        onClick={()=>history.push({
                            pathname: '/applicant/bank-transfers',
                            state:{
                                firm: firm,
                                isMembership:isMembership,
                                application: props.location?.state?.application
                            }
                        })}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer'}}>
                            <span className="general-span-text-none-auto">ATTACH PAYMENT PROOF</span>
                            <div className="item" >
                                <img src={bank_icon} style={{height: 150, width: 150}}/>
                            </div>
                        </div>
                    </div>
                </div>

        
               <PaymentModel
                    title={title}
                    show={showModel} 
                    hide={togglePaymentModel}
                    changeView={changeView}
                    setChangeView={setChangeView}
                    payLater={payLater}
                    setPayLater={setPayLater}
                    handlePayNow={handlePayNow}
                    handlePayLater={handlePayLater}
                    paymentMethod={paymentMethod}
                    handlePhoneNumber={handlePhoneNumber}
                    phoneNumber={phoneNumber}
                    loader={apiResponse.payLoader}
                    paymentDetails={apiResponse.billId}
                    applicationDetails={applicationDetails}
                    />
                <SuccessfulModel
                show={showSuccessModel}
                hide={handleCloseSuccessModel}/>
            </DashBoardContainer>
        </div>
    )
}

export default ApllicationPaymentDetails